<script> 
  let temp
  let utcOffset
  let timeOutput

// setInterval(time, 1000);

function weatherBalloon( cityID ) {
  var key = '172b3cfe715790703888c45f613af1b8';
  fetch('https://api.openweathermap.org/data/2.5/weather?id=' + cityID+ '&appid=' + key)  
  .then(function(resp) { return resp.json() }) // Convert data to json
  .then(function(data) {
    console.log(data);
    let kelvin = data.main.temp;
    let celsius = kelvin - 273;
    temp = Math.floor(celsius * (9/5) + 32);
    utcOffset = data.timezone;
    calcTime(utcOffset);
  })
  .catch(function() {
    // catch any errors
  });
}

window.onload = function() {
  weatherBalloon(4487042);
  setInterval(() => {
    calcTime(utcOffset);
  }, 1000);
}

function calcTime(offset) {
  var d = new Date();
  var utc = d.getTime();
  var utcCalc = (utc + (3600000 * offset));
  var nd = new Date(utcCalc);
  console.log("new date: " + nd);
  var s = nd.getSeconds();
  var m = nd.getMinutes();
  var h = nd.getHours();
  timeOutput =  ("0" + h).substr(-2) + ":" + ("0" + m).substr(-2) + ":" + ("0" + s).substr(-2);
  console.log(timeOutput);
}


let projects = [
  {
    name: 'Moving Water Visualization',
    url: 'https://www.movingwater.live/',
  },
  {
    name: 'Katie Harris Portfolio',
    url: 'https://www.katieharrisdesigns.com/',
  },
  {
    name: 'Maldek Recording Studio Website',
    url: 'http://maldekstudios.com/',
  },
]


</script>

<svelte:head>
  <title>Matthew Gluf</title>
  <!-- font -->
	<link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;300;400;500;600;700;800;900&display=swap" rel="stylesheet">
</svelte:head>

<div class="main">
  <div class="name">
    <h1>Matthew Gluf</h1>
  </div>
  <div class="content">
    <div class="info-container">
      <div class="info">
        <div class="label"><h3>Designer + Developer</h3></div>
        <div class="locale">
          <!-- <div class="icon icon-location"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5A5D64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg></div> -->
          <h3>Raleigh, NC</h3>
        </div>
        <div class="context">
          <div class="time">{timeOutput}</div>
          <div class="temp">{temp}°F</div>
        </div>
        <div class="nav">
          <li>
            <ul>
              <a target="_blank" href="https://read.cv/mgluf">
                read.cv
                <div class="icon icon-arrow icon-resume"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-right"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg></div>
              </a>
              </ul>
            <ul>
              <a target="_blank" href="mailto:gluf.matt@gmail.com">
                contact
                <div class="icon icon-arrow icon-contact"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-right"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg></div>
              </a>
            </ul>
          </li>
        </div>
      </div>
    </div>
  </div>
</div>

<style>

  .main {
    width: 70vw;
    height: auto;
    position: fixed;
    top: calc(50% - 22.5vh);
    left: calc(50% - 35vw);
    /* border: 5px solid rgb(108, 107, 109); */
    padding: 1rem;
  }

  .name h1 {
    font-size: 3rem;
    margin: 0;
  }

  .locale {
    color: rgb(172, 172, 172);
    display: flex;
    align-items: center;
    column-gap: .5rem;
    margin-bottom: .25rem;
  }

  .locale h3 {
    margin: 0;
  }

  .context {
    color: rgb(172, 172, 172);
    display: flex;
    column-gap: 1rem;
    margin-bottom: 1rem;
  }

  li {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  ul{
    margin: 0 0 .5rem 0;
    padding: 0;
  }

  ul a{
    width: fit-content;
    display: flex;
    column-gap: .5rem;
  }

  @media only screen and (max-width: 700px) {

    .main {
      width: -webkit-fill-available;
      left: unset;
    }
  }

</style>